import * as React from 'react';

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ReactFCC,
} from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { ArrowWrapper } from './styled';

interface IArrowProps {
  direction: 'left' | 'right';
  arrowMarginFromTop?: string;
  className?: string;
  onClick?: () => void;
}

export const Arrow: ReactFCC<IArrowProps> = ({
  direction,
  onClick,
  className,
  arrowMarginFromTop,
}) => {
  const isLeft = direction === 'left';
  const isNewPdDesignEnabled = useNewPdDesignEnabled();

  return (
    <ArrowWrapper
      className={className}
      onClick={onClick}
      isLeft={isLeft}
      arrowMarginFromTop={arrowMarginFromTop}
      isNewPdDesignEnabled={isNewPdDesignEnabled}
      role="button"
    >
      {isLeft ? (
        <ChevronLeftIcon color="icon.primary" width="20px" height="20px" />
      ) : (
        <ChevronRightIcon color="icon.primary" width="20px" height="20px" />
      )}
    </ArrowWrapper>
  );
};
